import { useMutation, useQueryClient } from '@tanstack/react-query';
import { removeCartransfer } from '../api/cartransferService';

/**
 * Hook para eliminar cartransfers
 */
export function useDeleteCartransfer() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: removeCartransfer,
    onSuccess: (data, id) => {
      // Invalidar queries relacionadas
      queryClient.invalidateQueries({ queryKey: ['cartransfers'] });
      queryClient.invalidateQueries({ queryKey: ['cartransfer', id] });
      queryClient.invalidateQueries({ queryKey: ['dashboard'] });
      return data;
    },
    onError: (error) => {
      console.error('Error deleting cartransfer:', error);
    },
  });
} 